<template>
    <div>
        <div class="content-header">
            <h3>客户查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item label="昵称">
                    <el-input v-model="formInline.nickName" placeholder="请输入用户昵称" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input v-model="formInline.mobile" placeholder="请输入用户手机" clearable></el-input>
                </el-form-item>
                <el-form-item label="openId">
                    <el-input v-model="formInline.openId" placeholder="请输入openId" clearable></el-input>
                </el-form-item>

                <el-form-item label="customerId">
                    <el-input v-model="formInline.customerId" placeholder="请输入customerId" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="formInline.isOnLine" checked true-label="1" false-label="0">在线</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCustomerLineList">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="用户头像">
                    <template slot-scope="scope">
                        <el-avatar size="small" :src="scope.row.headImageUrl"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="customerId" label="customerId"></el-table-column>
                <el-table-column prop="nickName" label="昵称"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="consultTime" label="最新咨询时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click="handleDetail(scope.row.customerId)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList} from '@/api/api';


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    isOnLine: 1,
                    nickName:'',
                    mobile:'',
                    openId:'',
                    customerId:''
                },
                recordsTotal:0
            }
        },
        //挂载时候执行
        mounted() {
            if(this.$route.query.openId){
                this.formInline.openId = this.$route.query.openId;
            }
            this.getCustomerLineList();
        },
        methods: {
            //定义查询方法
            getCustomerLineList() {
                this.loading = true;
                getCustomerList(this.formInline).then((res) => {
                    this.dataList = res.data.value.list
                    this.recordsTotal = res.data.value.total
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCustomerLineList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCustomerLineList()
            },
            handleDetail(row) {
//                row = '10003238884855992509385'
                this.$router.push({path:'/userSystem/detail/:tab/:id',name: 'userSystemContent',params:{id:row,tab:'info'}})
            },
        }
    }
</script>
<style scoped lang="scss" rel="stylesheet/scss" >
    .select-wrap{
        margin: 10px 10px 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/userSystem/userSystem.vue